export const getOrders = state => state.orders.list;

export const getOrderById = (id, state) =>
  state.orders.list.find(order => order.id === id);
